import createBrowserHistory from 'history/createBrowserHistory';

const customHistory = createBrowserHistory();
export default customHistory;



// WEBPACK FOOTER //
// ./src/js/utils/history.js